var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLayers = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4472 4.10557C12.1657 3.96481 11.8343 3.96481 11.5528 4.10557L2.55279 8.60557C2.21401 8.77496 2.00001 9.12123 2.00001 9.5C2.00001 9.87877 2.21401 10.225 2.55279 10.3944L11.5528 14.8944C11.8343 15.0352 12.1657 15.0352 12.4472 14.8944L21.4472 10.3944C21.786 10.225 22 9.87877 22 9.5C22 9.12123 21.786 8.77496 21.4472 8.60557L12.4472 4.10557ZM12 12.882L5.23607 9.5L12 6.11803L18.7639 9.5L12 12.882Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44722 13.6056C2.95324 13.3586 2.35257 13.5588 2.10558 14.0528C1.85859 14.5468 2.05881 15.1474 2.55279 15.3944L11.5528 19.8944C11.8343 20.0352 12.1657 20.0352 12.4472 19.8944L21.4472 15.3944C21.9412 15.1474 22.1414 14.5468 21.8944 14.0528C21.6474 13.5588 21.0468 13.3586 20.5528 13.6056L12 17.882L3.44722 13.6056Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLayers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/layers.64d0b6959d20980090c6c240610a3886.svg";